import { render, staticRenderFns } from "./ActivateAccount.vue?vue&type=template&id=6645e41c&"
import script from "./ActivateAccount.vue?vue&type=script&lang=js&"
export * from "./ActivateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports